const swiperSupport = new Swiper('.support-slider__contents', {
  loop: true,
  slidesPerView: 1.55,
  spaceBetween: 16,
  pagination: {
    el: '.support-pagination',
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  }
});